import React, { Component } from "react";
import "./assets/css/share-my-box.css";
import "../Panels/SharedComponents/brands.min.css";
import { withLDConsumer } from "ldclient-react"

import ShareEmail from './ShareEmail/ShareEmail';
import ShareTwitter from './ShareTwitter/ShareTwitter';
import ShareFacebookMessenger from './ShareFacebookMessenger/ShareFacebookMessenger';
import ShareFacebook from './ShareFacebook/ShareFacebook';
import ShareCopy from './ShareCopy/ShareCopy';
import ShareSnapchat from './ShareSnapchat/ShareSnapchat';

class ShareMyBox extends Component {

    getBoxId = (box) => {
        if(box && box.currentBox && box.currentBox.shipstationId > 0) return box.currentBox.shipstationId;
        return null;
    }
    render(){
        const { boxData, isMobile, firstName } = this.props.sysdata;
        const boxId = this.getBoxId(boxData);
        const url = `${window.location.origin}/my-box?boxID=${boxId}`;
        const userFirstName = firstName ? firstName.firstName : "your friend's";
        const flags = this.props.flags ? this.props.flags : null;
        const { 
            growthShareMyBoxEnableCopy, 
            growthShareMyBoxEnableEmail, 
            growthShareMyBoxEnableFb, 
            growthShareMyBoxEnableFbMessenger, 
            growthShareMyBoxEnableSnap, 
            growthShareMyBoxEnableTwitter } = flags;
        const isSharedBox = this.props.sysdata.isSharedBox;
        if (!boxId) {
            return (
                <div className="hor-rule" />
            );
        }
        return (
            <div className={"smb " + (isMobile ? "sizeSmall" : "sizeLarge")}>
                <p className="smb__title">{this.props.title}</p>
                <div className="smb__cont">
                    <div className="smb__icon-cont">
                        {growthShareMyBoxEnableFb ? <ShareFacebook url={url} /> : null}
                        {growthShareMyBoxEnableTwitter ? <ShareTwitter url={url} firstName={userFirstName} isSharedBox={isSharedBox}/> : null}
                        {growthShareMyBoxEnableFbMessenger ? <ShareFacebookMessenger url={url} isMobile={isMobile} /> : null}
                        {growthShareMyBoxEnableSnap ? <ShareSnapchat url={url} /> : null}
                        {growthShareMyBoxEnableEmail ? <ShareEmail url={url} firstName={userFirstName} isSharedBox={isSharedBox}/> : null}
                        {growthShareMyBoxEnableCopy ? <ShareCopy url={url} /> : null}
                    </div>
                    {isMobile ? null : <div className="smb__hor-rule"></div>}
                </div>
            </div>
        )
    }
}

export default withLDConsumer()(ShareMyBox);


// WEBPACK FOOTER //
// ./src/Components/ShareMyBox/ShareMyBox.js